// @flow strict

/* eslint-disable react/no-multi-comp */

import React from 'react';
import { Motion, spring, presets } from 'react-motion';

type WindowScrollProps = {
  scrollTop: number,
};

class WindowScroll extends React.Component<WindowScrollProps> {
  componentDidUpdate(previousProps) {
    if (previousProps.scrollTop !== this.props.scrollTop) {
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = this.props.scrollTop;
      }
    }
  }

  render() {
    return null;
  }
}

type ScrollToProps = {
  to: number,
  onRest: () => *,
};

export default class ScrollTo extends React.PureComponent<ScrollToProps> {
  static defaultProps = {
    onRest: () => {},
  };

  render() {
    const scrollingElement = document.scrollingElement || document.documentElement;

    if (!scrollingElement) return null;

    return (
      <Motion
        defaultStyle={{
          scrollTop: scrollingElement.scrollTop,
        }}
        style={{
          scrollTop: spring(this.props.to, presets.noWobble),
        }}
        onRest={this.props.onRest}>
        {currentStyles => <WindowScroll scrollTop={currentStyles.scrollTop} />}
      </Motion>
    );
  }
}
